import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import axiosInstance from '@libs/axios';
import { ppjkOptionsFrom, type CeisaUserRow } from './options';

/**
 * Every PPJK, for a picker. Only ask when the picker is shown: the server
 * returns other PPJKs to super admins and internal staff only — anyone else
 * gets their own, so the picker would have a single option anyway.
 */
export default function usePpjkOptions(ownNpwp: string | null | undefined, enabled: boolean) {
  const query = useQuery({
    queryKey: ['ppjk-picker-options'],
    queryFn: async ({ signal }): Promise<CeisaUserRow[]> => {
      // The endpoint defaults to 50 rows; a picker needs all of them.
      const response = await axiosInstance.get<{ data?: CeisaUserRow[] }>('/api/v1/master-ceisa?limit=1000', {
        signal,
      });
      return Array.isArray(response.data?.data) ? response.data.data : [];
    },
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  const options = useMemo(() => ppjkOptionsFrom(query.data ?? [], ownNpwp), [query.data, ownNpwp]);
  return { options, loading: query.isLoading };
}
